module.exports = __webpack_public_path__ + "static/media/logo.32c7f982.svg";